
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tidal-dashboard/ebay-views",
      function () {
        return require("private-next-pages/tidal-dashboard/ebay-views.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tidal-dashboard/ebay-views"])
      });
    }
  